import { Injectable } from "@angular/core";
import { BaseEntityService } from "./rest-common.service";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class ALIService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_API_URL}/line-item/`;

  getMetaData(params = {}) {
    return this.get(this.buildUrl(`${this.resource_url}li-meta/`, '', params));
  }

  getPublishers(params = {}) {
    params['res_type'] = 'publisher'
    return this.get(this.buildUrl(`${this.BASE_API_URL}/line-item/dashboard/publisher/`, '', params));
  }

  getSellers(params: Object = {}) {
    return this.get(this.buildUrl(`${this.BASE_API_URL}/seller/`, '', params));
  }

  getSizes() {
    return this.get(`${this.BASE_API_URL}/sizes/`);
  }

  activateDeactiveLineItem(id: number, action: 'activate' | 'deactivate', params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/line-item/${id}/${action}/`, '', params);
    return this.put(url, {});
  }

  addSplits(id, data, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/line-item/${id}/splits/`, '', params)
    return this.put(url, data)
  }

  getSplits(id, params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/line-item/${id}/splits/`, '', params)
    return this.get(url)
  }

  getAllSplits(params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/line-item/splits/`, '', params)
    return this.get(url)
  }

  mapBudgetInterval(lineItem, dailyBgtDisc = false) {
    let flight = dailyBgtDisc ? lineItem : lineItem.budget_intervals;
    flight.map((item) => {
      if (item.start_date != null) {
        var startDate = new Date(item.start_date); // Or the date you'd like converted.
        var isoStartDateTime = new Date(
          startDate.getTime() - startDate.getTimezoneOffset() * 60000
        ).toISOString().slice(0, 10);
        item.start_date = `${isoStartDateTime} 00:00:00`;
      }

      if (item.end_date != null) {
        var endDate = new Date(item.end_date); // Or the date you'd like converted.
        var isoEndDateTime = new Date(
          endDate.getTime() - endDate.getTimezoneOffset() * 60000
        ).toISOString().slice(0, 10);
        item.end_date = `${isoEndDateTime} 23:59:59`;
      }
    });
  }

  getBrandSafetySegments(params = {}) {
    let url = this.buildUrl(`${this.BASE_API_URL}/segment/brand-safety/`, '', params)
    return this.get(url)
  }

  getTimeZones(params) {
    let url = this.buildUrl(`${this.BASE_API_URL}/timezones/`, '', params)
    return this.get(url)
  }

  notifyFlightDiscrepancy(id: number, params = {}, data = {}) {
    let url = this.buildUrl(
      `${this.BASE_API_URL}/line-item/${id}/warn-li-flight-budget-discrepency/`,
      "",
      params
    );
    return this.post(url, data);
  }

  getAliChangeLogs(id, params ={}) {
    let url = this.buildUrl(`${this.resource_url}${id}/change-log`, '', params);
    return this.get(url);
  }

  getFlightUploadTemplate(params = {}) {
    let url = this.buildUrl(
      `${this.resource_url}download-bulk-upload-template`,
      "",
      params
    );
    return this.get(url);
  }

  uploadFlightsTemplate(params = {}, data) {
    let url = this.buildUrl(
      `${this.resource_url}bulk-upload-flights/`,
      "",
      params
    );
    return this.post(url, data);
  }

}
